import { render, staticRenderFns } from "./CvpFooter.vue?vue&type=template&id=bd892b7c&scoped=true&"
import script from "./CvpFooter.vue?vue&type=script&lang=js&"
export * from "./CvpFooter.vue?vue&type=script&lang=js&"
import style0 from "./CvpFooter.vue?vue&type=style&index=0&id=bd892b7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd892b7c",
  null
  
)

export default component.exports